module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-male-image.c6320f46.png";